<template>
  <div>
    <align class="header" flex>
      <h3 class="secondary-font">
        Ladder Headlines
      </h3>

      <icon-link as="router-link" to="/feed?f=Headline">
        View More
      </icon-link>
    </align>

    <!-- eslint-disable-next-line vue/no-v-html -->
    <p v-if="data.mostRecentHeadlines" v-html="data.mostRecentHeadlines.body" />

    <div v-if="data.mostRecentHeadlines" class="grid">
      <card-note
        v-for="(cardNote, i) in data.mostRecentHeadlines.cardNotes"
        :key="i"
        as="router-link"
        :to="`/dashboard?cardId=${cardNote.card}`"
        :card-note="cardNote"
      />
    </div>
  </div>
</template>

<script>
import CardNote from '@cardladder/shared/components/CardNote';

export default {
  components: {
    CardNote,
  },

  props: {
    data: Object,
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr;

  @media($large-up) {
    grid-template-columns: 1fr 1fr;

    .panel-open & {
      grid-template-columns: 1fr;
    }
  }

  @media($medium-down) {
    margin: 0 (-$gp);
  }
}

.header {
  margin: 0 0 $gp;
}

h3 {
  margin: 0;
}
</style>
